import { render, staticRenderFns } from "./EducationProgressReportBySubject.vue?vue&type=template&id=3b8f925a&"
import script from "./EducationProgressReportBySubject.vue?vue&type=script&lang=js&"
export * from "./EducationProgressReportBySubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports